<template>
    <div v-if="!canon || !gopro || !photos" class="media-status-header">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-sm-4">
                    <h1 class="warning d-flex align-items-center">Media Source<br>Currently Disabled</h1>
                </div>
                <div class="col-sm-5">
                    <ul class="disable-media">
                        <li v-if="!canon">BJ & SJ Canon</li>
                        <li v-if="!gopro">BJ & SJ GoPro</li>
                        <li v-if="!photos">BJ & SJ Photos</li>
                        <li v-if="!sw">SW Media</li>
                        <li v-if="!tc">TC Media</li>
                    </ul>
                </div>
                <div class="col-sm-3">
                    <a href="/ap/media-sources" class="red-button">Edit Media Status</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';

export default {
    computed: {
        ...mapState([
            'mediaStatus',
            'mediaStatusIsLoaded', 
            'mediaStatusHasDisabled'
        ]),
        canon() {
            return (this.mediaStatus.length) ? this.mediaStatus[0].status : true;
        },
        gopro() {
            return (this.mediaStatus.length) ? this.mediaStatus[1].status : true;
        },
        photos() {
            return (this.mediaStatus.length) ? this.mediaStatus[2].status : true;
        },
        sw() {
            return (this.mediaStatus.length) ? this.mediaStatus[3].status : true;
        },
        tc() {
            return (this.mediaStatus.length) ? this.mediaStatus[4].status : true;
        }
    },
    methods: {
        ...mapActions(['fetchMediaStatus']),
    },
    async created() {
        await this.fetchMediaStatus();
    }
}
</script>